import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/notification";

export const List = async (values) => {
  return await axiosInstance(options).get(`${path}/`, values);
};

export const Count = async () => {
  return await axiosInstance(options).get(`${path}/count`);
};

export const MarkRead = async (id) => {
  return await axiosInstance(options).patch(`${path}/mark-read/${id}`);
};

export const MarkAllRead = async () => {
  return await axiosInstance(options).patch(`${path}/mark-all-read`);
};

export const SendToUsers = async (values) => {
  return await axiosInstance(options).post(`${path}/send`, values);
};
